

export class AddToAlbumImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public listService:any;
  public paramsForAddingToAlbum:any;
  contextMenuService: any;
  static singleInstance:any = null;


  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
  }

  public static getInstance(globalService):AddToAlbumImplementation{
    if(this.singleInstance == null){
        this.singleInstance = new AddToAlbumImplementation(globalService);
    }
    return this.singleInstance;
}


  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.listService = globalService.getListServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
  }

  public loadDataForAddingToAlbum(files){
    this.universalService.popUpToBeOpened = "addToAlbum";
    return true;
  }


  public setRequiredDataForAddingtoAlbum(files){
    var array = []
    files.map(function(object){
      var objectKey;
      if(object["FullObject"]){
        objectKey = object["FullObject"]["objectKey"]
      }else{
        objectKey = object["objectKey"]
      }
      array.push({
        "objectKey":objectKey
      })
    })
    this.universalService.objectsToBeAdded = array;
    var params = {
      "objects" : this.universalService.objectsToBeAdded
    }
    this.paramsForAddingToAlbum = params
  }
}
